import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './routes';
import { UserProvider } from './UserContext/UserContext';
import CookieConsent from './components/CookieConsent/CookieConsent';

ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <Routes />
      <CookieConsent />
    </UserProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
